// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"navbar_mainContainer__dmHQv","links":"navbar_links__CFp3m","buttonsFont":"navbar_buttonsFont__FJOxd"};